import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';


export class ClearFix extends Mixin {
  style() {
    return css`
      .clearfix::after {
        display: block;
        clear: both;
        content: "";
      }
    `;
  }
}
